<script setup>
import ModalLayer from '~/components/UI/ModalLayer.vue'
import { modalStack } from '~/composables/useCustomModal'
</script>

<template>
  <teleport to="body">
    <ModalLayer
      v-for="modal in modalStack"
      :key="modal.id"
      :modal="modal"
    />
  </teleport>
</template>
